import { computed } from 'mobx';
import { defaultFragments, QueryType } from './features/Default';
import { loyaltyLevelCurrentFragments } from './features/LoyaltyLevelCurrent';
import { loyaltyLevelNextFragments } from './features/LoyaltyLevelNext';

export type IQueryTypeFragments = {
    [key in QueryType]?: string;
};

export class QueryFragments {
    // dynamically construct a list with all enabled fragments
    @computed
    public get enabledFragments() {
        const availableFragments: { [key in string]?: string } = {
            userInfo: defaultFragments()[QueryType.userInfo],
            loyaltyLevelCurrent: loyaltyLevelCurrentFragments()[QueryType.loyaltyLevelCurrent],
            loyaltyLevelNext: loyaltyLevelNextFragments()[QueryType.loyaltyLevelNext]
        };

        return availableFragments;
    }

    // dynamically construct a list of fragment
    @computed
    public get queryFragments() {
        const availableFragments: IQueryTypeFragments = {
            User: '...userInfo ',
            LoyaltyLevelCurrent: '...loyaltyLevelCurrent ',
            LoyaltyLevelNext: '...loyaltyLevelNext '
        };

        return availableFragments;
    }
}
